<template>
    <div>
        <div style="height: 20vh;" class="inapp-hide"></div>
        <Riassunto :iscrizione="false"/>
        <div class="v-step step active">
            <b-form-group label="La tua squadra è stata creata, ora cosa vorresti fare?">
                <b-form-radio-group v-model="form.scelta">
                    <b-form-radio value="iscrizione"
                                  class="d-block mb-2 v-custom-control v-custom-radio v-custom-control-inline">
                        Voglio iscrivermi alla Race
                    </b-form-radio>
                    <b-form-radio value="iscrizione-team"
                                  class="d-block mb-2 v-custom-control v-custom-radio v-custom-control-inline">
                        Voglio aggiungere degli iscritti alla mia squadra
                    </b-form-radio>
                    <b-form-radio value="fine"
                                  class="d-block mb-2 v-custom-control v-custom-radio v-custom-control-inline">
                        Direi che è tutto
                    </b-form-radio>
                </b-form-radio-group>
            </b-form-group>

            <div class="v-step__footer-step">
                <b-button :disabled="!compiled('scelta')" variant="primary" @click="submit">
                    Conferma
                </b-button>
            </div>
        </div>
        <div style="height: 30vh;"></div>
    </div>
</template>

<script>
    import BaseForm from "../BaseForm";
    import Riassunto from "./Riassunto";

    export default {
        name: "TeamCreato",
        extends: BaseForm,
        components: {Riassunto},
        data() {
            return {
                form: {
                    scelta: null
                }
            }
        }, methods: {
            submit() {
                switch (this.form.scelta) {
                    case 'iscrizione':
                        this.$store.commit('nomyself', false) // Devo committarlo anche se non sarebbe necessario in quanto potrei essere tornato indietro con il browser
                        this.goTo('inserimento-dati')
                        break;
                    case 'iscrizione-team':
                        this.$store.commit('nomyself', false)
                        this.goTo('inserimento-dati')
                        break;
                    case 'fine':
                        window.location.href = "/race/thank-you/creazione-team?registrazione_id_team="+this.$store.state.team.id;
                        break;
                    default:
                        console.log('scelta sconosciuta', this.form.scelta)
                }
            }
        }
    }
</script>

<style scoped>

</style>